import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'markets',
  inputShow: gql`
    query markets($input: MarketQueryInput) {
      markets(input: $input) {
        id
        display_name
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Rates',
    label: 'Markets',
  },
};
